const layerOverrideVisibility = {
    ALWAYS_HIDE: 'ALWAYS_HIDE',
    ALWAYS_SHOW: 'ALWAYS_SHOW',
};

export default layerOverrideVisibility;
